import { types } from "mobx-state-tree";

import { MenuItems } from "../../components/secondary-menu/SecondaryMenu";
import {
  ViewJob,
  ViewJobFromAssignedProject,
  CreateJob,
  ViewSewerObjectsLinkedToJob,
  ViewSewerObjectsLinkedToAssignedJobOrJobProject,
} from "../../services/authorization/Permissions";
import { permissionsService } from "../../services/authorization/UserPermissionsService";

export enum JobDynamicMenuItemsPages {
  EditJob,
}

export const JobMenuItemsModel = types
  .model({
    jobId: types.optional(types.number, 0),
    isLoading: false,
    createMode: types.optional(types.boolean, false),
    dynamicMenuItemPage: types.maybe(types.frozen<JobDynamicMenuItemsPages>()),
    numberOfSewerObjects: types.optional(types.number, 0),
  })
  .actions((self) => {
    const canAccessJobDetailsPage = () =>
      self.createMode
        ? permissionsService.userHasPermissionTo(CreateJob)
        : permissionsService.userHasOneOfThePermissions([ViewJob, ViewJobFromAssignedProject]);

    const canAccessJobSewerObjectsMapPage = () =>
      permissionsService.userHasOneOfThePermissions([
        ViewSewerObjectsLinkedToJob,
        ViewSewerObjectsLinkedToAssignedJobOrJobProject,
      ]);

    const canAccessJobSewerObjectsPage = () =>
      self.createMode ||
      permissionsService.userHasOneOfThePermissions([
        ViewSewerObjectsLinkedToJob,
        ViewSewerObjectsLinkedToAssignedJobOrJobProject,
      ]);

    const getJobDetailsPath = () => (self.createMode ? "/create-job" : `/${self.jobId}`);

    const isJobSewerObjectsPageDisabled = () => self.createMode || self.isLoading;

    return {
      getStaticItems(): MenuItems {
        return {
          "general.general": {
            items: [
              {
                id: "secondary-menu-jobs-details",
                labelKey: "general.jobs.details",
                path: getJobDetailsPath(),
                canAccess: canAccessJobDetailsPage(),
                disabled: self.isLoading,
                isActive: self.dynamicMenuItemPage === JobDynamicMenuItemsPages.EditJob,
              },
            ],
            defaultOpen: true,
          },
          "general.manage": {
            items: [
              {
                id: "secondary-menu-sewer-objects",
                labelKey: "general.sewer-objects",
                path: `/${self.jobId}/sewer-objects`,
                canAccess: canAccessJobSewerObjectsPage(),
                disabled: isJobSewerObjectsPageDisabled(),
              },
              {
                id: "secondary-menu-map",
                labelKey: "general.sewer-objects.map",
                path: `/${self.jobId}/map`,
                canAccess: canAccessJobSewerObjectsMapPage(),
                disabled: isJobSewerObjectsPageDisabled(),
              },
            ],
            defaultOpen: true,
          },
        };
      },
    };
  });
